import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent'
import { useToaster } from '../../shared/utils/ToasterProvider';
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import { IdAutoCompleteField } from '../../shared/components/formfields/IdAutoCompleteField';
import { useGetAllTrainerList } from '../../assets/nodeApi/getApi/getHrApi';
import { Box, Button, Grid2, Stack, Typography } from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { postGenerateTrinerSalary } from '../../assets/nodeApi/postApi/postCommonApi';
import { DateFormField } from '../../shared/components/formfields/DataFormField';
import { Grid_Gap, Input_Width } from '../../shared/constants';
import CustomDivider from '../../shared/utils/CustomDivider';
import { useState } from 'react';
import ToggleSwitch from '../../shared/utils/CustomToggle';
import { useDialog } from '../../shared/hook/useDialog';
import MainDialogBox from '../../shared/components/Dialog/MainDialogBox';
import { formatKey } from '../../shared/formatter';

const TrainerSalaryCalculate = () => {
    const { showToaster } = useToaster();
    const { data: trainerList, isLoading: istrainerLoading } = useGetAllTrainerList({ salaryExists: true })
    const { open, handleClickOpen, handleClose } = useDialog();
    const [calculatedSalary, setCalculatedSalary] = useState()
    const handleToggleChange = (isChecked) => {
        setShowActiveOnly(isChecked);
    };
    const [showActiveOnly, setShowActiveOnly] = useState(false);
    const trainerOption = trainerList?.data?.map((item, index) => ({
        id: item?.id,
        value: `${item.firstname} ${""} ${item.lastname}`,
        label: `${item.firstname} ${""} ${item.lastname}`
    })) ?? [];
    const mutation = useMutation({
        mutationFn: (formdata) => postGenerateTrinerSalary(formdata),
    });
    const handleSubmit = (values, { resetForm }) => {
        mutation.mutate(values,
            {
                onSuccess: (response) => {
                    setCalculatedSalary(response?.data)
                    showToaster(response?.message, '', 'success');
                    resetForm();
                },
                onError: (err) => {
                    console.error(err);
                    showToaster(err?.response?.data?.message || "Failed to generate Salary ", "", "error");
                },
            }
        );
    };

    return (

        <>
            <NormalContainerWithHeader headerText={"Salary Generate"}>
                <Formik
                    initialValues={{
                        trainer_id: '',
                        from: '',
                        to: '',
                    }}
                    enableReinitialize={true}
                    validationSchema={Yup.object().shape({
                        trainer_id: Yup.string()
                            .required('Trainer is required'),
                        from: Yup.date()
                            .required('From Date is required')
                            .typeError('Invalid date'),
                        to: Yup.date()
                            .required('To Date is required')
                            .typeError('Invalid date')
                    })}

                    onSubmit={handleSubmit}
                >
                    {({ values, resetForm }) => (
                        <Form>
                            <Grid2 container spacing={Grid_Gap}>
                                <Grid2 children size={Input_Width}>
                                    <Field
                                        name="trainer_id"
                                        options={trainerOption}
                                        component={IdAutoCompleteField}
                                        label="Trainer"
                                        isRequired
                                        isLoading={istrainerLoading}
                                    />
                                </Grid2>

                                <Grid2 children size={Input_Width}>
                                    <Field
                                        name="from"
                                        component={DateFormField}
                                        label="From Date"
                                        isRequired={true}
                                        maxDate={(() => {
                                            const yesterday = new Date();
                                            yesterday.setDate(yesterday.getDate() - 1);
                                            return values.to_date && new Date(values.to_date) < yesterday
                                                ? new Date(values.to_date)
                                                : yesterday;
                                        })()}
                                    />
                                </Grid2>

                                <Grid2 children size={Input_Width}>
                                    <Field
                                        name="to"
                                        component={DateFormField}
                                        label="To Date"
                                        isRequired={true}
                                        minDate={values.from || undefined}
                                        maxDate={(() => {
                                            const yesterday = new Date();
                                            yesterday.setDate(yesterday.getDate() - 1);
                                            return yesterday;
                                        })()}
                                    />
                                </Grid2>

                            </Grid2>
                            <CustomDivider />
                            <Grid2 container spacing={Grid_Gap}>
                                <Grid2 children size={Input_Width} >
                                    <Button variant="outlined" onClick={resetForm} fullWidth>
                                        Reset
                                    </Button>
                                </Grid2>
                                <Grid2 children size={Input_Width}>
                                    <Button variant="contained" type="submit" fullWidth disabled={mutation.isPending}>
                                        {mutation.isPending ? "Submitting" : "Submit"}
                                    </Button>
                                </Grid2>

                            </Grid2>
                        </Form>
                    )}
                </Formik>

                <CustomDivider />

                {
                    calculatedSalary &&
                    <Box>
                        <Stack direction={"row"} justifyContent={"space-between"} gap={Grid_Gap}>

                            <Typography variant='h4'>Salary Detail</Typography>
                            <Button onClick={handleClickOpen} variant='contained'>View Attandance</Button>
                            <ToggleSwitch checked={showActiveOnly} onCheck={handleToggleChange} checkedText="Include Bonus" unCheckedText="Include Bonus" />

                        </Stack>
                        <CustomDivider />
                        {Object?.entries({
                            "Trainer Name": `${calculatedSalary?.trainer?.firstname || ""} ${calculatedSalary?.trainer?.lastname || ""}`,
                            "Email": calculatedSalary?.trainer?.email,
                            "Mobile": calculatedSalary?.trainer?.mobile,
                            "From Date": calculatedSalary?.from,
                            "To Date": calculatedSalary?.to,
                            "Pay Type": calculatedSalary?.pay_type,
                            "Total Classes": calculatedSalary?.total_classes,
                            "Total Hours": calculatedSalary?.total_hours,
                            ...(calculatedSalary?.monthly_salary ? { "Monthly Salary": calculatedSalary?.monthly_salary } : {}),
                                                        ...(calculatedSalary?.monthly_salary ? { "Total Working Days": calculatedSalary?.total_working_days } : {}),
                            ...(calculatedSalary?.per_class_rate ? { "Per Class Salary": calculatedSalary?.per_class_rate } : {}),
                            ...(calculatedSalary?.per_hour_rate ? { "Per Hour Salary": calculatedSalary?.per_hour_rate } : {}),
                            ...(showActiveOnly ? { "Bonus": calculatedSalary?.bonus } : {}),
                            "Total Salary": showActiveOnly
                                ? calculatedSalary?.calculated_salary_with_bonus
                                : calculatedSalary?.calculated_salary_without_bonus,
                        } ?? {}).map(([key, value]) => (
                            <Box display="flex" alignItems="center" key={key} mb={1}>
                                <Typography
                                    variant="body1"
                                    fontWeight={600}
                                    sx={{ width: "35%", display: "inline-block" }}
                                >
                                    {formatKey(key)}
                                </Typography>
                                <Typography
                                    variant="body1"
                                    sx={{ width: "5%", textAlign: "center" }}
                                >
                                    :
                                </Typography>
                                <Typography
                                    variant="body1"
                                    sx={{ width: "50%", wordBreak: "break-word" }}
                                >
                                    {value}
                                </Typography>
                            </Box>

                        ))}
                    </Box>
                }

            </NormalContainerWithHeader>

            <MainDialogBox open={open} handleClose={handleClose} width={"40%"} heading={"  Attendance Summary"}>


                {calculatedSalary?.attendance_summary?.length > 0 ? (
                    calculatedSalary?.attendance_summary.map((item, index) => (
                        <Grid2
                            container
                            key={index}
                            spacing={1}
                            alignItems="center"
                            sx={{ mb: 1, pb: 1 }}
                        >
                            <Grid2 children size={4}>
                                <Typography variant="body1" fontWeight={500}>
                                    {item.date}
                                </Typography>
                            </Grid2>
                            <Grid2 children size={4}>
                                <Typography variant="body2">
                                    Classes: {item.total_classes}
                                </Typography>
                            </Grid2>
                            <Grid2 children size={4}>
                                <Typography variant="body2">
                                    Hours: {item.total_hours}
                                </Typography>
                            </Grid2>
                            {index !== calculatedSalary?.attendance_summary.length - 1 && (
                                <CustomDivider size={5}/>
                            )}
                        </Grid2>
                    ))
                ) : (
                    <Typography color="text.secondary">No attendance data found.</Typography>
                )}
            </MainDialogBox>

        </>
    )
}

export default TrainerSalaryCalculate
